import 'bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import "react-datepicker/dist/react-datepicker.css";
import Navigation from './navigation';
import { toast, ToastContainer } from 'react-toastify';
import { Provider, useSelector } from 'react-redux';
import store from './components/redux/Store';
import { PersistGate } from 'redux-persist/integration/react';
import persistStore from 'redux-persist/es/persistStore';

const App = () => {

  const persistor = persistStore(store);
  return (
    <>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <div className="App">
            <Navigation />
            <ToastContainer />
          </div>
        </PersistGate>
      </Provider>
    </>
  );
};

export default App;
